module.exports = __webpack_public_path__ + "static/media/doctor.418b7b96.jpg";